import { useEffect } from 'react';
import WebMercatorViewport from 'viewport-mercator-project';
import turfBbox from '@turf/bbox';
import useGlobalState from '../../hooks/use-global-state';
import { FlyToInterpolator } from 'deck.gl';
import { setLGAGeo } from '../../modules/app-duck';

const useFitbounds = (setViewport, geojson) => {
  useEffect(() => {
    if (!geojson) {
      return;
    }
    setViewport(viewport => {
      const bbox = turfBbox(geojson);
      const newViewport = new WebMercatorViewport(viewport).fitBounds(
        [bbox.slice(0, 2), bbox.slice(2, 4)],
        { padding: { top: 10, right: 10, bottom: 10, left: 10 } }
      );
      return {
        ...viewport,
        ...newViewport,
        transitionInterpolator: new FlyToInterpolator(),
        transitionDuration: 500,
      };
    });
  }, [geojson, setViewport]);
};

export const useLGA = setViewport => {
  const { state, dispatch } = useGlobalState();
  // const [lgaGeo, setLGAGeo] = useState(null);

  useEffect(() => {
    const baseUrl = process.env.URL || '';
    if (!state.lga) {
      setLGAGeo(null);
      return;
    }
    fetch(`${baseUrl}/lga/${state.lga}.geojson.gz`)
      .then(x => x.json())
      .then(geo => {
        dispatch(setLGAGeo(geo));
      });
  }, [dispatch, state.lga]);
  useFitbounds(setViewport, state.lgaGeo);
  return state.lgaGeo;
};
